import React, { useRef } from 'react'
import { AboutInnerBanner } from '../Components/Common/InnerBanner/AboutInnerBanner'
import AboutInnBanContent from '../Components/Common/InnerBanner/AboutInnBanContent'
import { Link } from 'react-router-dom';
import cOne from "../Assets/images/contact/contact-1.png";
import CTwo from "../Assets/images/contact/contact-2.png";
import cThree from "../Assets/images/contact/contact-3.png";
import Transition from '../Components/Transition';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Helmet } from 'react-helmet';
import { contactus } from "../api/api";

const Contact = () => {
    const { image, heading, pageName } = AboutInnBanContent.Contact;
    const form = useRef();  // ✅ Only once

    const formik = useFormik({
        initialValues: {
            fname: '',
            email: '',
            phone: '',
            subject: '',
            message: ''
        },
        validationSchema: Yup.object({
            fname: Yup.string().required("Name is required"),
            email: Yup.string().email("Invalid email address").required("Email is required"),
            phone: Yup.string().matches(/^[0-9]{10}$/, "Enter a valid 10-digit phone number").required("Phone number is required"),
            subject: Yup.string().required("Subject is required"),
            message: Yup.string().required("Message is required")
        }),
        onSubmit: async (values, { resetForm }) => {
            try {
                console.log("Sending:", values);
                const res = await contactus(values);
                console.log("Response:", res.data);
                alert("Message sent successfully ✅");
                resetForm();
            } catch (error) {
                console.error(error);
                alert("API Error ❌");
            }
        },
    });

    return (
        <>
            <Helmet>
                <title>Best Contact Information | Acme Fertility Hospital Mumbai</title>
                <meta name='description' content='Reach Acme Fertility Hospital for appointments and inquiries. Call, email, or visit us at our Chembur, Mumbai location.' />
                <meta name='keywords' content='' />
                <link rel="canonical" href="https://www.acmefertility.com/Contact" />
                <meta name="robots" content="Index, follow" />
            </Helmet>

            <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

            <div className="appointment-area ptb-100">
                <div className="container">
                    <div className="row">

                        {/* Left Contact Info */}
                        <div className="col-lg-4">
                            <div className="contact-us-card">

                                <div className="cus-items d-flex">
                                    <div className="contact-last-img col-md-4">
                                        <img src={cOne} alt="phone" />
                                    </div>
                                    <div className="cus-info col-md-8">
                                        <h6>Contact Us Free</h6>
                                        <Link className="cus-a">022 - 69770000</Link>
                                        <Link>+91 8655 00 6567</Link>
                                    </div>
                                </div>

                                <div className="cus-items d-flex">
                                    <div className="contact-last-img col-md-4">
                                        <img src={CTwo} alt="email" />
                                    </div>
                                    <div className="cus-info col-md-8">
                                        <h6>Email Us</h6>
                                        <Link className="cus-a">help@acmefertility.com</Link>
                                        <Link>contact@acmefertility.com</Link>
                                    </div>
                                </div>

                                <div className="cus-items d-flex cus-items2">
                                    <div className="contact-last-img col-md-4">
                                        <img src={cThree} alt="location" />
                                    </div>
                                    <div className="cus-info col-md-8">
                                        <h6>Hospital Address</h6>
                                        <p className="cus-p">402, 4th Floor, Signature Business Park, Postal Colony Road, Near Chembur Mono Rail Station, Chembur, Mumbai - 400071</p>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* Right Contact Form */}
                        <div className="col-lg-8">
                            <div className="appointment-from">
                                <span>Get In Touch</span>
                                <h3>Contact Us</h3>

                                <form ref={form} onSubmit={formik.handleSubmit} id="contactForm" className="contact-from">
                                    <div className="row">

                                        {/* Name */}
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    name="fname"
                                                    className="form-control"
                                                    placeholder="Name"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.fname}
                                                />
                                                <div className="error">
                                                    {formik.touched.fname && formik.errors.fname ? formik.errors.fname : null}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Email */}
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <input
                                                    type="email"
                                                    name="email"
                                                    className="form-control"
                                                    placeholder="Email"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.email}
                                                />
                                                <div className="error">
                                                    {formik.touched.email && formik.errors.email ? formik.errors.email : null}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Phone */}
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <input
                                                    type="number"
                                                    name="phone"
                                                    className="form-control"
                                                    placeholder="Phone"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.phone}
                                                />
                                                <div className="error">
                                                    {formik.touched.phone && formik.errors.phone ? formik.errors.phone : null}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Subject */}
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    name="subject"
                                                    className="form-control"
                                                    placeholder="Subject"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.subject}
                                                />
                                                <div className="error">
                                                    {formik.touched.subject && formik.errors.subject ? formik.errors.subject : null}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Message */}
                                        <div className="col-12">
                                            <div className="form-group">
                                                <textarea
                                                    className="form-control"
                                                    name="message"
                                                    id="message"
                                                    cols="30"
                                                    rows="8"
                                                    placeholder="Message"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.message}
                                                ></textarea>
                                                <div className="error">
                                                    {formik.touched.message && formik.errors.message ? formik.errors.message : null}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Submit Button */}
                                        <div className="col-lg-12">
                                            <button
                                                type="submit"
                                                className="common-btn style1"
                                                disabled={formik.isSubmitting}
                                            >
                                                {formik.isSubmitting ? "Submitting..." : "Submit Now"}
                                            </button>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default Transition(Contact);